import { Box, Typography } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.Loyalty.Rewards.Columns;

type Props = {
  pointsLabel: string;
};

export const RewardsListHeader = ({ pointsLabel }: Props) => {
  const { t } = useResource();

  return (
    <Box display="flex" py={1.5} borderBottom={1} borderColor="divider">
      <Typography fontWeight={600} fontSize="0.875rem" flex={1}>
        {t(RESOURCES.Date)}
      </Typography>
      <Typography fontWeight={600} fontSize="0.875rem" flex={2}>
        {t(RESOURCES.Activity)}
      </Typography>
      <Typography
        fontWeight={600}
        fontSize="0.875rem"
        minWidth={100}
        textAlign="right"
      >
        {pointsLabel}
      </Typography>
    </Box>
  );
};
